module.exports = __webpack_public_path__ + "img/ach_katan_yes.4e84c587.png";